import styled from 'styled-components';
import Card from 'components/Card';
import { motion } from 'framer-motion';
import { th } from 'style/theme';
import { sizes } from 'style';

export const CardContainer = styled(motion.div)`
  margin-bottom: auto;
  width: 100%;
  margin-top: 25px;

  @media ${sizes.tabletPortrait} {
    width: 370px;
  }

  @media (min-width: 835px) {
    margin-top: 0;
  }

  @media ${sizes.desktop} {
    margin-right: 45px;
  }
`;

export const UserInfoCard = styled(Card).attrs({ variant: 'global' })`
  position: relative;
  border-radius: 7px;
  padding: 18px 23px 24px 23px;
  background-color: ${th('colors.fiord')};
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  margin-bottom: 16px;

  :last-child {
    margin-bottom: 0;
  }

  > :first-child {
    width: 115px;
    font-size: 14px;
    font-weight: bold;
  }

  > :last-child {
    position: relative;
    flex: 1;
    font-size: 14px;
    word-break: break-word;

    > svg {
      font-size: 18px;
      color: ${th('colors.turquoise')};
      cursor: pointer;
      position: absolute;
      right: 0;
    }
  }
`;
